import React,{useState} from 'react'
import InputField from "../../common/InputField";
import TextareaField from "../../common/TextAreaField";
import FormValidator from "./FormValidator";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Button,
 
} from "@material-ui/core";
import "./styles.scss";
import {registerStartupCohort} from "./dependencies/action"
import Checkbox from "@mui/material/Checkbox";
import Select, { components, DropdownIndicatorProps } from "react-select";
const defaultFormData = {
  startup_name: "",
  startup_enrolmentid: "",
  applyto_cohort:"",
  disclaimer: false,
 
};
function CohortStartupForm(props) {
  const [formData, setFormData] = useState(defaultFormData);
  const [error, setError] = useState({});
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
    const { registerStartupCohort } =props;
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  const oncheckedChange = (e) => {
    setFormData((user) => {
      return { ...user, disclaimer: !formData.disclaimer };
    });
  };
  const handleInputChange = (e) => {
    // alert(e.target.name)
    // const { value, name } = e.target;
    // // alert(value)
    // setFormData((user) => {
    //   return { ...user, [name]: value };
    // });
    // 
    try {
      if (e.target.name === "uploadAttach") {
        setFormData((user) => {
          return { ...user, [e.target.name]: e.target.files[0] };
        });
      }  else if(e.target.name==="startup_enrolmentid"){
        const { value, name } = e.target;
        setFormData((user) => {
          return { ...user, [name]: value };
        });
        if(value.indexOf(' ') >= 0){
          

        setFormData((user) => {
          return { ...user,["enrolementIds"]: value };
          
        });
        
        setFormData((user) => {
          return { ...user, [name]: "" };
        });
        // setFormData(prevState => ({
        //   myArray: [...prevState, ["setFormData"new value"]
        // }))
        
        
      }
      }else {
        const { value, name } = e.target;

        setFormData((user) => {
          return { ...user, [name]: value };
        });
      }
    } catch (error) {}
  };
  const validateStep1Input = () => {
    const { startup_name, startup_enrolmentid,applyto_cohort, disclaimer } = formData;
    const formStatus = FormValidator.validateStep1({
      startup_name,
      startup_enrolmentid,
      applyto_cohort,
      disclaimer,
    });

    const errors = {
      startup_name: formStatus.startup_name,
      startup_enrolmentid: formStatus.startup_enrolmentid,
      applyto_cohort: formStatus.applyto_cohort,
      disclaimer: formStatus.disclaimer,
      // orgName: formStatus.orgName,
    };
    setError(errors);
    
    return !formStatus.hasErrors;
  };
  const onBlur=()=>{
    validateStep1Input();
  }
  const renderErrorMessage = (name) => {
    return (
      <div style={{ paddingLeft: "0px" }}>
        <div className="login-error-msg">{name}</div>
      </div>
    );
  };
  const onSubmit=()=>{
    if (!validateStep1Input()) {
      setHasInvalidSubmitOccurred(true);
    } else {
      // onclickShowSubmitCohort();
  //  alert("form is submitted")
      setTimeout(() => {
        
        addFormData(formData);
      }, 1500);
      
    }
  }
  const addFormData = (submitData) => {
    

    const newformData = new FormData();

    

    const cohortStartupapplication = {
     
      disclaimer: submitData.disclaimer,
     
      startup_name: submitData.startup_name,
     
      startup_enrolmentid: submitData.startup_enrolmentid,
      applyto_cohort: submitData.applyto_cohort,
      
    };

    newformData.append("application", JSON.stringify(cohortStartupapplication));

   
    registerStartupCohort(cohortStartupapplication).then((res) => {
      if (res) {
        
       
      }
    });
   
  };
  return (
    <div
    className="cohortstartupformsteps row"
    style={{ paddingBottom: "10px", marginTop:"25px" }}
  >
            <InputField
                required={true}
                id="startup_name"
                label="STARTUP NAME"
                variant="outlined"
                // placeholder="Type Here.."
                fullWidth
                margin="normal"
                onChange={handleInputChange}
                value={formData.startup_name}
                name="startup_name"
                error={error.startup_name}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
               <InputField
                required={true}
                id="startup_enrolmentid"
                label="STARTUP ENROLMENT ID"
                variant="outlined"
                // placeholder="Type Here.."
                fullWidth
                margin="normal"
                type='number'
                onChange={handleInputChange}
                value={formData.startup_enrolmentid}
                name="startup_enrolmentid"
                error={error.startup_enrolmentid}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              <h6>WHY DO YOU WANT TO APPLY TO THIS COHORT ? </h6>
              <TextareaField
              required={true}
              id="applyto_cohort"
              // className="textarea"
              onChange={handleInputChange}
              variant="outlined"
              placeholder="Describe in maximum 500 words"
              fullWidth
              margin="normal"
              value={formData.applyto_cohort}
              name="applyto_cohort"
              // multiline
              rows={2}
              maxRows={4}
              // error={error.applyto_cohort}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />
            {error.applyto_cohort && renderErrorMessage(error.applyto_cohort)}
             <div className="disclaimerMaindiv">
               
                <Checkbox
                  

                  checked={formData.disclaimer}
                  onClick={() => oncheckedChange()}
                  onBlur={onBlur}
                  sx={{
                    color: "#F78F54",
                    "&.Mui-checked": {
                      color: "#F78F54",
                    },
                  }}
                />
                <div
                 
                  className="actualdisclaimer"
                >
                  We are in compliance with the provisions of the various Acts,
                  Rules, Regulations, Guidelines, Standards applicable to the
                  entity from time to time. All information provided by us in
                  the application is true, correct and complete and no
                  information material to the subject matter of this form has
                  been suppressed or concealed. If there is any change in this
                  information or compliance status, I will duly inform Startup
                  India within 15 days on startup.support@investindia.org.in
                </div>
                
              </div>
              {error.disclaimer && renderErrorMessage(error.disclaimer)}
              <Button
        // className={classes.button}
        variant="contained"
        color="primary"
        style={{
          // marginRight: theme.spacing(1),
          backgroundColor: "#3AC2D7",
          color: "#fff",
          width: "150px",
          marginTop: "20px",
          marginLeft:"38%"
        }}
        onClick={onSubmit}
        
      >
        submit
        {/* <i className="fa fa-arrow-right"></i> */}
      </Button>
      
              </div>
  )
}
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  registerStartupCohort,
 
})(withRouter(CohortStartupForm));


